// src/app/manufacturer-grid/manufacturer-grid.component.ts
import { Component, OnInit } from '@angular/core'; 
import { ManufacturerService } from '../Services/manufacture.service';
import { Manufacturer } from "../objects/Manufacturer";
import { Router } from '@angular/router'; 
@Component({
  selector: 'app-manufacturer-grid',
  templateUrl: './manufacturer-grid.component.html',
  styleUrls: ['./manufacturer-grid.component.css'],
})
export class ManufacturerGridComponent implements OnInit {
  manufacturers: Manufacturer[] = [];
  isMobile?: boolean;

  constructor(private manufacturerService: ManufacturerService, public router: Router) {}
  
  
  ngOnInit() {
    this.checkisMobile()
    this.loadManufacturers();
  }

  loadManufacturers() {
    this.manufacturerService.getManufacturers().subscribe((manufacturers) => {
      this.manufacturers = manufacturers;
    });
  }
    
  editManufacturer(manufacturer: Manufacturer) {
  // Implement the edit functionality here
  // You can open a dialog or navigate to a separate edit page with the material's data
  
  this.router.navigate(['manufacturers/edit', manufacturer.id]);
    // Implement the edit functionality here
    // You can open a dialog or navigate to a separate edit page with the material's data
 
  console.log('Editing equipment:', manufacturer);

  
}


checkisMobile() { 
     
  const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  if(width < 768)
  {this.isMobile = true;
  }
    else
  {this.isMobile = false;}
  
  
}
delete(whatever:any){
  if(window.confirm('Are sure you want to delete ' + whatever.name + '?')){
  //put your delete method logic here 
  this.manufacturerService.deletetManufacturer(whatever).subscribe((result) => {
    console.log('Manufacturer removed successfully!');
     
    this.router.navigate(['/manufacturers']);
    
    this.loadManufacturers();
  });
     
 }
}
}